











import { defineComponent, inject, reactive, ref, watch } from '@vue/composition-api'
import Editor from '@/components/Editor.vue'
import TextCheckbox from './components/TextCheckbox.vue'
import { EntityType } from '@/api/project/model'
import { typeDurationOption } from '@/api/project/duration-option'
import TimeCustomSelect from '@/components/TimeCustomSelect.vue'
import _ from 'lodash'
import { useProjectStore } from '@/pinia/modules/project'
import { storeToRefs } from 'pinia'

export default defineComponent({
    components: {
        Editor,
        TextCheckbox,
        TimeCustomSelect
    },
    setup(props, { root }) {
        const itemObj: any = inject('itemObj')
        const itemWay: any = inject('itemWay')
        const projectStore = useProjectStore()
        const { projectInfo } = storeToRefs(projectStore)
        if (itemWay.value == 'create') {
            itemObj.message_entity.entity_type = EntityType.ask_experience
            itemObj.message_entity.duration = typeDurationOption[EntityType.ask_experience].value
        }

        watch(
            () => itemObj.message_entity.settings,
            (newValue, oldValue) => {
                const options = newValue[0]?.options
                if (options) {
                    const optionsCopy = _.cloneDeep(itemObj.message_entity.options)
                    itemObj.message_entity.options = itemObj.message_entity.options.filter((item: any) => !item.is_system)
                    if (options.other) {
                        const opt = optionsCopy.find((v: any) => v.is_system && v.option_type == 'other')
                        itemObj.message_entity.options.push(
                            opt
                                ? opt
                                : {
                                      is_system: true,
                                      text: root.$t('projectSurvey.optionType.other', projectInfo.value.detail_language),
                                      is_show: true,
                                      option_type: 'other'
                                  }
                        )
                    }
                    if (options.none) {
                        const opt = optionsCopy.find((v: any) => v.is_system && v.option_type == 'none')
                        itemObj.message_entity.options.push(
                            opt
                                ? opt
                                : {
                                      is_system: true,
                                      text: root.$t('projectSurvey.optionType.none', projectInfo.value.detail_language),
                                      is_show: true,
                                      option_type: 'none'
                                  }
                        )
                    }
                    itemObj.message_entity.options.forEach((option: any, index: number) => {
                        option.sequence = index
                    })
                }
            },
            {
                deep: true
            }
        )

        return {
            itemObj,
            EntityType
        }
    }
})
